import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { cleanChatAsync, downloadChatAsync, downloadDocumentAsync, getChatHistoryAsync, getClausesAsync, initiateChatAsync, sendMessageAsync } from './chatThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initiateChatAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(initiateChatAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.chatSetupResponse = action.payload;
        })
            .addCase(initiateChatAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(sendMessageAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(sendMessageAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.chatResponse = action.payload;
        })
            .addCase(sendMessageAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getChatHistoryAsync.pending, (state, action) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getChatHistoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.chatHistory = action.payload;
        })
            .addCase(getChatHistoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(cleanChatAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(cleanChatAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.cleanedChat = action.payload;
        })
            .addCase(cleanChatAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(downloadDocumentAsync.pending, (state, action) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(downloadDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.donwloadDocumentResponse = action.payload;
        })
            .addCase(downloadDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(downloadChatAsync.pending, (state, action) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(downloadChatAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.downloadedChat = action.payload;
        })
            .addCase(downloadChatAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getClausesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getClausesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.clausesData = action.payload;
        })
            .addCase(getClausesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default chatSlice.reducer;
